import { useAtomValue } from "jotai";
import React from "react";
import { Sidebar } from "src/components";
import styled from "styled-components";

import { sidebarWidth } from "../Sidebar/Sidebar";
import { Color, Flex } from "src/elements";
import {
  O_ASK_DOCK_PX,
  O_ASK_DRAWER_PX,
  oAskDockedAtom,
} from "src/components/ConfigCopilot/store/oAskDock";

const PageContainer = styled(Flex)<{ hasSidebar: boolean; $isOAskDocked: boolean }>`
  padding: ${({ hasSidebar }) => hasSidebar && `0 0 0 ${sidebarWidth}px`};
  background: ${Color.white};
  height: 100vh;

  // Ask O's drawer is open on a wide window: leave its width free, so nothing sits under it.
  @media (min-width: ${O_ASK_DOCK_PX}px) {
    ${({ $isOAskDocked }) => $isOAskDocked && `padding-right: ${O_ASK_DRAWER_PX}px;`}
  }
`;

const Main = styled(Flex)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

interface Props {
  children: React.ReactNode;
  hasSidebar?: boolean;
}

export const Page = ({ children, hasSidebar = true }: Props) => {
  const isOAskDocked = useAtomValue(oAskDockedAtom);
  return (
    <PageContainer hasSidebar={hasSidebar} $isOAskDocked={isOAskDocked} data-testid="page">
      {hasSidebar && <Sidebar />}

      <Main>{children}</Main>
    </PageContainer>
  );
};
